import React from 'react';
import { StyledTutorial } from './styles/StyledTutorial';

const Tutorial  = () => (
  <StyledTutorial >
  Tutorial:
  <pre>
  sử dụng (←,→) để di chuyển<br/>
  sử dụng (↑) để xoay khối  <br/>
  ấn giữ ↓ để drop nhanh hơn
  </pre>
  
  </StyledTutorial> 
);

export default Tutorial;